import { gql, useQuery } from "@apollo/client";
import React, { createContext, useContext } from "react";
import { useGetMe } from "./GetMeContext";
import { useKitchenDetail } from "./GetMyKitchenDetailContext";

const InventoryContext = createContext();

const GET_INVENTORY = gql`
  query getMyInventoryDetail($kitchenId: ID!, $userId: ID!) {
    getMyInventoryDetail(kitchen_id: $kitchenId, user_id: $userId) {
      inventoryType
      count
    }
  }
`;
export const MyInventoryProvider = ({ children }) => {
  const {user} = useGetMe(); // Get user data from context
  const userdata = user?.me; // User data
  const { kitchenDetail } = useKitchenDetail();

  console.log("userdata", userdata)

  const { loading, data, refetch } = useQuery(GET_INVENTORY, {
    variables: { kitchenId: kitchenDetail?.kitchenId, userId: userdata?.id },
    skip: !kitchenDetail?.kitchenId || !userdata?.id,
  });

  return (
    <InventoryContext.Provider
      value={{ inventory: data?.getMyInventoryDetail, loading, refetch }}
    >
      {children}
    </InventoryContext.Provider>
  );
};

export const useInventory = () => useContext(InventoryContext);
